"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { FieldInspectorProps } from "../../lib/inspector";
import type { TeaserItemInspectorProps } from "../../patterns/teaser-grid/teaser-grid";
import {
  Divisions,
  type DivisionsInspectorProps,
  type DivisionsProps,
} from "./divisions";

function mergeInspectorField(
  custom: FieldInspectorProps | undefined,
  generated: FieldInspectorProps | undefined
): FieldInspectorProps | undefined {
  if (!(custom || generated)) {
    return;
  }

  return { ...custom, ...generated };
}

export function DivisionsPreview(props: Readonly<DivisionsProps>) {
  const assemblyInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });
  const itemInspector = useContentfulInspectorMode();

  const generatedAssemblyInspectorProps: DivisionsInspectorProps = {
    container: assemblyInspector({ fieldId: "internalName" }) ?? undefined,
    divisions: assemblyInspector({ fieldId: "divisions" }) ?? undefined,
  };

  const inspectorProps: DivisionsInspectorProps = {
    container: mergeInspectorField(
      props.inspectorProps?.container,
      generatedAssemblyInspectorProps.container
    ),
    divisions: mergeInspectorField(
      props.inspectorProps?.divisions,
      generatedAssemblyInspectorProps.divisions
    ),
  };

  const divisions = props.divisions.map((division) => {
    const generatedItemInspectorProps: TeaserItemInspectorProps = {
      container:
        itemInspector({
          entryId: division.sys?.id,
          fieldId: "internalName",
        }) ?? undefined,
      image:
        itemInspector({ entryId: division.sys?.id, fieldId: "image" }) ??
        undefined,
      link:
        itemInspector({ entryId: division.sys?.id, fieldId: "link" }) ??
        undefined,
    };

    return {
      ...division,
      inspectorProps: {
        container: mergeInspectorField(
          division.inspectorProps?.container,
          generatedItemInspectorProps.container
        ),
        image: mergeInspectorField(
          division.inspectorProps?.image,
          generatedItemInspectorProps.image
        ),
        link: mergeInspectorField(
          division.inspectorProps?.link,
          generatedItemInspectorProps.link
        ),
      },
    };
  });

  return (
    <Divisions
      {...props}
      divisions={divisions}
      inspectorProps={inspectorProps}
    />
  );
}
